export default __webpack_public_path__ + "06fef19782aae8ca920afb2b563a027b.svg";